import { render, staticRenderFns } from "./TableReceiptDetail.vue?vue&type=template&id=5254ed04&"
import script from "./TableReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./TableReceiptDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5254ed04')) {
      api.createRecord('5254ed04', component.options)
    } else {
      api.reload('5254ed04', component.options)
    }
    module.hot.accept("./TableReceiptDetail.vue?vue&type=template&id=5254ed04&", function () {
      api.rerender('5254ed04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/receipts/views/components/TableReceiptDetail.vue"
export default component.exports